import React from "react";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { Error } from "../UI/Error";

export function InputField({
  label,
  multiline,
  InputLabelProps,
  error,
  placeholder,
  register,
  type,
  readOnly,
  defaultValue,
  disable,
  rows,
  onChange,
  sx,
  onKeyDown,
  value,
  min,
  max,
  maxLength,
  minLength,
  pattern,
  onInput,
  helperText,
  InputProps,
  size
}) {
  return (
    <FormControl variant="standard" fullWidth>
      <TextField
        disabled={disable}
        // InputLabelProps={InputLabelProps}
        InputLabelProps={{}}
        InputProps={{
          inputProps: {
            step: 0.01,
            min: min,
            max: max,
            pattern: pattern,
            minLength: minLength,
            maxLength: maxLength,
          },
          ...InputProps
        }}
        sx={{ ...sx }}
        rows={rows}
        multiline={multiline}
        size={size}
        variant="outlined"
        label={label}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        type={type}
        error={error && true}
        {...register}
        onChange={onChange}
        onKeyDown={onKeyDown}
        he
      />
      {error && <Error message={helperText} />}
    </FormControl>
  );
}

export function OutlineInputField({
  defaultValue,
  label,
  error,
  register,
  endAdornment,
  updatedValue,
  type,
  size,
  onClick,
  disable,
  readOnly,
  helperText,
  multiline,
  rows
}) {
  return (
    <FormControl fullWidth>
      <InputLabel error={error && true}>{label}</InputLabel>
      <OutlinedInput
        readOnly={readOnly}
        defaultValue={defaultValue}
        disabled={disable}
        onClick={onClick}
        endAdornment={endAdornment}
        label={label}
        type={type}
        value={updatedValue}
        variant="outlined"
        error={error && true}
        {...register}
        multiline={multiline}
        rows={rows}
      />
      {error && <Error message={helperText} />}
    </FormControl>
  );
}
